import React, { useEffect, useRef, useState } from 'react';
import { TSectionTabsProps } from '../../../types/PrivacyStatement.types';
import { debounceHandler } from '../../../../../utils/debounceHandler.utils';
import { documentService } from '../../../../../utils/window.utils.js';

const SectionTabs = (props: TSectionTabsProps) => {
    const { contentWrapperRef, privacyContentItems } = props;
    const parentContainerTopPadding = 40;
    const headerHeight = 100;
    const breadcrumbHeight = 56;
    const [ activeItem, setActiveItem ] = useState<number>(0);
    const timmerRef = useRef<ReturnType<typeof setTimeout>>();
    const [isFromClick, setIsFromClick] = useState(false);
    const isFromClickRef = useRef<boolean>();
    isFromClickRef.current = isFromClick;

    const handleScroll = () => {
        debounceHandler(() => {

            if (isFromClickRef.current) {
                setIsFromClick(false);
                return;
            }

            const contentTabs = documentService()?.querySelectorAll('.privacy-statement-v2__content-tab');
            const tabsCount = contentTabs.length;

            const contentWrapperTop = (contentWrapperRef?.current?.getBoundingClientRect()?.top ?? 0) + 60;
            for (let i = (tabsCount - 1); i >=0; i--) {
                const tabTop = contentTabs[i]?.getBoundingClientRect()?.top;
                if (tabTop <= contentWrapperTop) {
                    setActiveItem(i);
                    break;
                }
                setActiveItem(0);
            }
        }, timmerRef, 100);
    };

    useEffect(() => {
        documentService()?.body.scrollIntoView();
    }, []);

    useEffect(() => {
        contentWrapperRef && contentWrapperRef?.current?.addEventListener('scroll', handleScroll);
        return () => {
            contentWrapperRef && contentWrapperRef?.current?.removeEventListener('scroll', handleScroll);
        }
    }, [contentWrapperRef]);

    const scrollItem = (id: string) => {
        const ele = documentService()?.getElementById(`${id}`);
        if (ele) {
            documentService()?.querySelector('.privacy-statement-v2__content-wrapper')?.scrollTo(0, ele.offsetTop  - parentContainerTopPadding - headerHeight - breadcrumbHeight);
            documentService()?.body.scrollIntoView();
        }
    };

    return (
        <ul className="privacy-statement-v2__tabs">
            { privacyContentItems ?
                privacyContentItems.map((item, index) => {
                    return <li className={`privacy-statement-v2__tab ${activeItem === index ? 'privacy-statement-v2__tab--active' : ''}`} onClick={() => {
                        scrollItem(item.id);
                        setIsFromClick(true);
                        setActiveItem(index);
                    }}>{item?.fields?.anchorContentTitle?.value}</li>
                }) : <div></div>
            }
        </ul>
    )
}

export default SectionTabs;
